import { render, staticRenderFns } from "./InternalOrder.vue?vue&type=template&id=6f0b5c52"
import script from "./InternalOrder.vue?vue&type=script&lang=js"
export * from "./InternalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports